import React, { useRef } from 'react';
var VeltCommentSidebarV2ResetFilterButton = function (props) {
    var defaultCondition = props.defaultCondition, children = props.children;
    var ref = useRef(null);
    return (React.createElement("velt-comment-sidebar-reset-filter-button-v2", { ref: ref, "default-condition": [true, false].includes(defaultCondition) ? (defaultCondition ? 'true' : 'false') : undefined }, children));
};
export default VeltCommentSidebarV2ResetFilterButton;
